<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn outlined small fab dark class="transparent" @click.stop="$router.push('/organisation/bailleurs')">
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Activités du projet {{ $route.params.projet.ll_programme }} ( {{ $route.params.projet.abbr_bailleur }} )

      <v-spacer></v-spacer>

      <v-btn outlined small fab dark class="transparent" @click.stop="$router.push('/organisation/bailleurs')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>

      <v-dialog v-model="dialogActivite" persistent max-width="600px">
        <v-card>
          <v-card-title>Activite</v-card-title>
          <v-card-text>

            <v-form ref="formActivite" v-model="valid" lazy-validation>
              <v-text-field v-model="ll_parcours" label="Activité" prepend-icon="post_add" :rules="nameRules"
                required></v-text-field>
              <v-text-field v-model="abbr_parcours" label="Abbréviation" prepend-icon="post_add" :rules="nameRules"
                required></v-text-field>
              <v-select dense :items="Themes" :rules="[(v) => !!v || 'Item is required']" label="Thèmes" item-value="id"
                item-text="ll_theme" required v-model="theme_selected" ref="theme_selected" return-object>
              </v-select>
              <v-textarea v-model="description_parcours" prepend-icon="short_text" label="Description"
                :rules="nameRules" required></v-textarea>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded class="primary" text @click="closeDialog">Annuler</v-btn>
            <v-btn rounded class="primary" text @click="updateCreateActivite">Sauvegarder</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn color="blue-grey" class="ma-2 white--text" rounded @click="dialogActivite = !dialogActivite">
        <v-icon left dark> mdi-plus-circle-outline </v-icon>
        Nouvelle activité
      </v-btn>

      <v-btn color="blue" class="ma-2 white--text" @click="GetActivites()" rounded>
        <v-icon left dark> mdi-reload </v-icon>
        Recharger
      </v-btn>

      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">id</th>
                <th class="text-left">abbréviation</th>
                <th class="text-left">Bailleur</th>
                <th class="text-left">Activité</th>
                <th class="text-left">Thème</th>
                <th class="text-left">Description</th>
                <th class="text-left">choix</th>
                <th class="text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in Activites" :key="index">
                <td>{{ item.id }}</td>
                <td>{{ item.abbr_parcours }}</td>
                <td>{{ item.ll_bailleur }}</td>
                <td>{{ item.ll_parcours }}</td>
                <td>{{ item.ll_theme }}</td>
                <td>{{ item.description_parcours }}</td>
                <td>
                  <v-chip v-if="item.choixCodeProducteur" class="ma-2" color="secondary">
                    CP
                  </v-chip>
                  <v-chip v-if="item.choixChefDeMenage" class="ma-2" color="primary">
                    CM
                  </v-chip>
                </td>
                <td>
                  <v-btn
                    @click="listeEtapesActivites(item)"
                    x-small
                    color="primary"
                    rounded
                    dark
                  >
                    Etapes
                  </v-btn>
                  <!--    <v-btn
                    @click="listeCampagneActivites(item)"
                    x-small
                    color="secondary"
                    rounded
                    dark
                  >
                    Campagnes
                  </v-btn> -->
                  <v-btn @click="openDialogActivite(item)" x-small color="warning" rounded dark>
                    Editer
                  </v-btn>
                  <v-btn x-small color="danger" rounded dark> Supprimer </v-btn>
                  <v-btn x-small color="green" @click="goToStats(item)" rounded dark> Formations </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-card-text>
    <v-form ref="formActivite" v-model="valid" lazy-validation></v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogActivite: false,
      idActivite: null,
      abbr_parcours: "",
      description_parcours: "",
      ll_parcours: "",
      theme_selected: "",
      dialogDeleteActivite: false,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  created() {
    if (!this.$route.params.projet) {
      console.log("pas de paramètres", this.$route.params.projet);

      this.$router.go(-1);
    }
    this.GetActivites();
  },
  methods: {
    ...mapActions({
      GetActivites: "Activites/GetAll",
    }),
    /*    filterActivites(activites) {
      //console.log(projets);
      return _.filter(activites, {
        programmes_id_programme: this.$route.params.projet.id,
      });
    }, */
    goToStats(item) {
      this.$router.push({
        path: "/organisation/statsFormationsProjets",
        query: item,
      });
    },
    updateCreateActivite() {
      let self = this;
      //console.log("Theme selected:", this.theme_selected);

      if (this.$refs.formActivite.validate()) {
        if (!this.idActivite) {
          let uuid = this.$uuid.v4();
          const newActivite = {
            abbr_parcours: this.abbr_parcours,
            description_parcours: this.description_parcours,
            ll_parcours: this.ll_parcours,
            ll_programme: this.$route.params.projet.ll_programme,
            ll_theme: this.theme_selected.ll_theme,
            programmes_id_programme: this.$route.params.projet.id,
            themes_id_theme: this.theme_selected.id,
            created: self.$firebase.firestore.FieldValue.serverTimestamp(),
            id_bailleur: this.$route.params.projet.id_bailleur,
            bailleurs_id_bailleur: this.$route.params.projet
              .bailleurs_id_bailleur,
            abbr_bailleur: this.$route.params.projet.abbr_bailleur,
            objectifs: this.$route.params.projet.objectifs,
            ll_bailleur: this.$route.params.projet.ll_bailleur,
          };
          console.log("New Activite:", newActivite);

          // Add a new document in collection "activites"
          this.$firebase
            .firestore()
            .collection("activites")
            .doc(uuid)
            .set(newActivite)
            .then(function () {
              console.log("Activite successfully written!");
              self.idActivite = null;
            })
            .catch(function (error) {
              console.error("Error writing Activite: ", error);
            });
          self.idActivite = null;
        } else {
          const updatedActivite = {
            abbr_parcours: this.abbr_parcours,
            description_parcours: this.description_parcours,
            ll_parcours: this.ll_parcours,
            ll_programme: this.$route.params.projet.ll_programme,
            ll_theme: this.theme_selected.ll_theme,
            programmes_id_programme: this.$route.params.projet.id,
            themes_id_theme: this.theme_selected.id,
            updated: self.$firebase.firestore.FieldValue.serverTimestamp(),
            id_bailleur: this.$route.params.projet.id_bailleur,
            bailleurs_id_bailleur: this.$route.params.projet
              .bailleurs_id_bailleur,
            abbr_bailleur: this.$route.params.projet.abbr_bailleur,
            objectifs: this.$route.params.projet.objectifs,
            ll_bailleur: this.$route.params.projet.ll_bailleur,
          };
          console.log("Activite id : ", self.idActivite);
          console.log("Activite updated : ", updatedActivite);
          var activiteRef = this.$firebase
            .firestore()
            .collection("activites")
            .doc(self.idActivite);
          activiteRef.set(updatedActivite, { merge: true });
        }
        self.idActivite = null;
        this.closeDialog();
        this.GetActivites();
      }
    },
    listeEtapesActivites(activite) {
      this.$router.push({
        name: "organisation-etapes-id",
        params: { activite },
      });
    },
    listeCampagneActivites(activite) {
      console.log(activite);
    },
    openDialogActivite(activite) {
      this.theme_selected = {
        ll_theme: activite.ll_theme,
        id: activite.themes_id_theme,
      };
      this.idActivite = activite.id;
      this.dialogActivite = true;
      this.abbr_parcours = activite.abbr_parcours;
      this.description_parcours = activite.description_parcours;
      this.ll_parcours = activite.ll_parcours;
      //this.theme_selected = activite.theme_selected;
    },
    closeDialog() {
      this.dialogActivite = false;
      this.dialogDeleteActivite = false;
      this.$refs.formActivite.reset();
    },
  },
  computed: {
    ...mapState({
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      //Activites: (state) => state.Activites.Activites,
      Themes: (state) => state.Themes.Themes,
      Activites(state) {
        return _.filter(state.Activites.Activites, {
          programmes_id_programme: this.$route.params.projet.id,
        });
      },
    }),
  },
};
</script>

<style lang="scss" scoped></style>
